<template>
    <input class="custom-currency-input" v-model="internalValue" :placeholder="placeholder" :id="id" @input="handleInput"
        :required="required" :disabled="disabled" @blur="onBlur" :min="min" :size="size" />
</template>

<script>
export default {
    name: 'CustomCurrencyInput',
    props: {
        value: Number,
        placeholder: {
            type: String,
            default: ''
        },
        id: {
            type: String,
            default: ''
        },
        required: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        },
        onBlur: Function,
        currencyCharacter: {
            type: String,
            default: '£'
        },
        size: {
            type: Number,
            default: 10,
        },
        min: {
            type: Number,
            default: 0,
        },
    },
    computed: {
        internalValue() {
            if (!this.value) {
                return ''
            } else {
                const indexDots = this.value.indexOf('.');
                if (indexDots === -1) {
                    const integerPartFormated = new Intl.NumberFormat('en-US').format(this.value.replace(this.currencyCharacter, '').replaceAll(',', ''))
                    return `${this.currencyCharacter}${integerPartFormated}`
                } else {
                    const integerPart = this.value.slice(0, indexDots),
                        decimalPart = this.value.slice(indexDots, this.value.length),
                        integerPartFormated = new Intl.NumberFormat('en-US').format(integerPart.replace(this.currencyCharacter, '').replaceAll(',', ''))
                    return `${this.currencyCharacter}${integerPartFormated}${decimalPart}`;
                }
            }
        },
    },
    methods: {
        handleInput(evt) {
            const value = evt.target.value.replace(/[^.,\d]/g, "");
            let valueFormated = '';
            if (value != 0) {
                const indexDots = value.indexOf('.');
                if (indexDots === -1) {
                    valueFormated = new Intl.NumberFormat('en-US').format(value.replace(this.currencyCharacter, '').replaceAll(',', ''));
                } else {
                    let decimalPart = value.slice(indexDots, value.length).replaceAll(',', '');
                    const countDots = decimalPart.split('.').length - 1;
                    const lastChar = decimalPart[decimalPart.length - 1];
                    if (countDots > 1 && (lastChar === '.' || lastChar === '.')) {
                        decimalPart = decimalPart.slice(0, -1);
                    }
                    valueFormated = decimalPart.includes('.') ? `${value.slice(0, indexDots)}${decimalPart}` : value;
                }
            }
            if (value.includes(this.currencyCharacter) && valueFormated.includes(this.currencyCharacter)) {
                evt.target.value = valueFormated;
            } else {
                evt.target.value = valueFormated == 0 ? '' : `${this.currencyCharacter}${valueFormated}`;
            }
            this.$emit('input', evt.target.value === `${this.currencyCharacter}0` ? '' : evt.target.value.replaceAll(',', '').replace(this.currencyCharacter, ''));
        }
    }
}
</script>
<style lang="scss" scoped>
.custom-currency-input {
    background-color: #fff;
    padding: 0 10px;
    font-size: 1.1em !important;
    border: 2px solid #dbdbdb;
    box-shadow: none;
    border-radius: 7px;
    text-align: center !important;

    &::placeholder {
        text-align: left;
    }
}
input {
    height: 35px !important;
}
</style>